export default {"src":"/_next/static/media/InfoTooltip.32ca52c0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};